(() => {
  const duration = 300;
  const easing = 'cubic-bezier(0.4, 0, 0.2, 1)';

  function finishAnimation(item, animation, isOpening) {
    if (item.featuredCaseAnimation !== animation) return;

    item.open = isOpening;
    item.style.removeProperty('height');
    item.style.removeProperty('overflow');
    item.featuredCaseAnimation = null;
  }

  function animateItem(item, isOpening) {
    const summary = item.querySelector('summary');
    if (!summary) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      item.open = isOpening;
      return;
    }

    if (item.featuredCaseAnimation) item.featuredCaseAnimation.cancel();

    const startHeight = item.getBoundingClientRect().height;
    if (isOpening) item.open = true;
    const endHeight = isOpening ? item.scrollHeight : summary.getBoundingClientRect().height;

    item.style.height = `${startHeight}px`;
    item.style.overflow = 'hidden';

    const animation = item.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      { duration, easing }
    );

    item.featuredCaseAnimation = animation;
    animation.onfinish = () => finishAnimation(item, animation, isOpening);
    animation.oncancel = () => {
      if (item.featuredCaseAnimation === animation) item.featuredCaseAnimation = null;
    };
  }

  function initialiseAccordion(accordion) {
    if (accordion.dataset.accordionReady === 'true') return;
    accordion.dataset.accordionReady = 'true';

    const items = [...accordion.querySelectorAll('.featured-case-study__accordion-item')];

    items.forEach((item) => {
      const summary = item.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        const shouldOpen = !item.open;

        if (shouldOpen) {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.open) animateItem(otherItem, false);
          });
        }

        animateItem(item, shouldOpen);
      });
    });
  }

  function initialise(root = document) {
    root.querySelectorAll('[data-featured-case-accordion]').forEach(initialiseAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
